
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from "../layouts/main";
import Loader from "../components/common/Loader";
import useTranslation from "next-translate/useTranslation";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import axios from "axios";
import Link from "next/link";
import classNames from "classnames";
const HowToBuy = () => {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [postFetch, setPostFetch] = useState(false);
    const [blogData, setBlogData] = useState({
        data: [],
        pages: 1
    });
    const [params, setParams] = useState({
        page: 1,
        perPage: 6
    });
    const PostItem = ({ post, i }) => {
        return <article className={'post_item'} data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-out-quad" data-aos-delay={100 * (i + 1)}>
            <div className={'post_item_wrapper'}>
                <Link href={post.article_link} className={'post_item_img'}>
                    <img src={post.picture_link} alt={post.title}/>
                </Link>
                <h2>
                    <Link href={post.article_link} className={'post_item_title'}>
                        {post.title}
                    </Link>
                </h2>
                <p className={'post_item_text'}>{post.text}</p>
                <span className={'post_item_date'}>{new Date(post.updated_at).toLocaleDateString()}</span>
            </div>
        </article>;
    };
    const getBlogData = async () => {
        return await axios.get('/api/get-blog-data', {
            params: {
                ...params
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
    };
    useEffect(() => {
        let appLoading = new Promise((resolve, reject) => {
            setTimeout(resolve, 2000, true);
        });
        let blogApiData = new Promise((resolve, reject) => {
            getBlogData().then(data => {
                resolve();
                setBlogData(data.data);
            }).catch((err) => {
                resolve();
                setBlogData({
                    data: [],
                    pages: 1
                });
            });
        });
        Promise.all([appLoading, blogApiData]).then(values => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    useEffect(() => {
        loaded && getBlogData().then(data => {
            setBlogData(data.data);
            setPostFetch(false);
        }).catch((err) => {
            setBlogData({
                data: [],
                pages: 1
            });
            setPostFetch(false);
        });
    }, [params]);
    return (<MainLayout title={seo.blog.title} description={seo.blog.description} keywords={seo.blog.keywords} page={'home'} alternate={'blog'} loaded={loaded}>
            <div className='banner_bg'>
                <Header t={t}/>
            </div>
            <main className='main'>
                <section className={`blog_section`}>
                    <div className="container">
                        <h1 className={'blog_section_title'}>GoodEgg Blog</h1>

                        <ul className={classNames({
            'blog_items': true,
            'postLoading': postFetch
        })}>
                            {blogData?.data?.length ? blogData.data.map((post, i) => {
            return <PostItem i={i} ket={post.created_at} post={post}/>;
        }) : <li className={'no_posts'}>No Posts...</li>}
                        </ul>
                        {blogData.pages && blogData?.pages > 1 && <div className={'pagination_wrapper'}>
                            <ul className={'pagination_items'}>
                                {Array.from({ length: blogData.pages }, (v, i) => i + 1).map(el => {
                return <li onClick={() => {
                        window.scrollTo({
                            top: 0
                        });
                        setPostFetch(true);
                        setParams({
                            ...params, page: el
                        });
                    }} key={el} className={'pagination_item_wrapper'}>
                                        <span className={classNames({
                        'pagination_item': true,
                        'active': params.page === el
                    })}>{el}</span>
                                    </li>;
            })}
                            </ul>
                        </div>}
                    </div>
                </section>

            </main>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </MainLayout>);
};
export default HowToBuy;

    async function __Next_Translate__getStaticProps__192c28627b2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__192c28627b2__ as getStaticProps }
  